<template lang="pug">
.map-offcanvas__item
  //- Header
  .map-offcanvas__title
    span(uk-icon="icon: location; ratio: .7")
    div &nbsp;避難所情報

  //- Content
  .map-offcanvas__body(v-if="Object.keys(open_shelters_list).length > 0")
    .uk-padding-small.uk-padding-remove-vertical
      ul.uk-list.uk-margin-remove(uk-accordion)
        li(v-for="shelters, area_name in open_shelters_list", :key="`area_${area_name}`")
          a.uk-accordion-title(href="#")
            .uk-flex.uk-flex-middle
              span {{ area_name }}&nbsp;
              span.uk-badge {{ shelters.length }}
          .uk-accordion-content
            ul.uk-list.uk-list-square
              li(v-for="shelter in shelters", :key="`shelter_${shelter.props.name}`")
                a(href="#", @click.prevent="handlePopup(shelter)") {{ shelter.props.name }}

  //- Else
  .map-offcanvas__body(v-else) 現在開設中の避難所はありません。

</template>

<script>
import * as types from "../js/mutations/map-mutations"

export default {
  computed: {
    open_shelters_list () { return this.$store.getters.open_shelters_list },
  },

  methods: {
    handlePopup (layer) {
      this.$store.dispatch(types.TOGGLE_LAYER, {layer_name: 'shelter_markers', state: true})
      this.$store.dispatch(types.POPUP, layer)
    }
  }
}

</script>
